// extracted by mini-css-extract-plugin
export default {"report_option_dialog_body":"GenerateTickReportDialog_report_option_dialog_body__WGZYX"};